
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import StockLevelsTab from "./advanced-inventory/StockLevelsTab";
import ExpiryTrackerTab from "./advanced-inventory/ExpiryTrackerTab";
import AutoRestockTab from "./advanced-inventory/AutoRestockTab";
import SupplierStockViewTab from "./advanced-inventory/SupplierStockViewTab";
import StockAdjustmentsTab from "./advanced-inventory/StockAdjustmentsTab";
import ForecastingTab from "./advanced-inventory/ForecastingTab";
import StockMovementLogTab from "./advanced-inventory/StockMovementLogTab";
import InventoryInsightsTab from "./advanced-inventory/InventoryInsightsTab";

interface LocationState {
  defaultTab?: string;
}

const AdvancedInventory = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>("stock-levels");
  
  useEffect(() => {
    // Check if a default tab was passed in the location state
    const locationState = location.state as LocationState;
    if (locationState?.defaultTab) {
      setActiveTab(locationState.defaultTab);
    }
  }, [location]);

  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-bold">Advanced Inventory Management</h1>
      <p className="text-muted-foreground">
        Manage stock levels, track inventory movements, and set up automated alerts.
      </p>
      
      <Tabs defaultValue={activeTab} value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid grid-cols-4 lg:grid-cols-8 mb-4">
          <TabsTrigger value="stock-levels">Stock Levels</TabsTrigger>
          <TabsTrigger value="expiry-tracker">Expiry Tracker</TabsTrigger>
          <TabsTrigger value="auto-restock">Auto-Restock</TabsTrigger>
          <TabsTrigger value="supplier-stock">Supplier Stock</TabsTrigger>
          <TabsTrigger value="stock-adjustments">Stock Adjustments</TabsTrigger>
          <TabsTrigger value="forecasting">Forecasting</TabsTrigger>
          <TabsTrigger value="stock-movement">Stock Movement</TabsTrigger>
          <TabsTrigger value="inventory-insights">Inventory Insights</TabsTrigger>
        </TabsList>
        
        <Card>
          <CardContent className="p-6">
            <TabsContent value="stock-levels" className="mt-0">
              <StockLevelsTab />
            </TabsContent>
            
            <TabsContent value="expiry-tracker" className="mt-0">
              <ExpiryTrackerTab />
            </TabsContent>
            
            <TabsContent value="auto-restock" className="mt-0">
              <AutoRestockTab />
            </TabsContent>
            
            <TabsContent value="supplier-stock" className="mt-0">
              <SupplierStockViewTab />
            </TabsContent>
            
            <TabsContent value="stock-adjustments" className="mt-0">
              <StockAdjustmentsTab />
            </TabsContent>
            
            <TabsContent value="forecasting" className="mt-0">
              <ForecastingTab />
            </TabsContent>
            
            <TabsContent value="stock-movement" className="mt-0">
              <StockMovementLogTab />
            </TabsContent>
            
            <TabsContent value="inventory-insights" className="mt-0">
              <InventoryInsightsTab />
            </TabsContent>
          </CardContent>
        </Card>
      </Tabs>
    </div>
  );
};

export default AdvancedInventory;
